import AdditionalInformation from './AdditionalInformation';

export default AdditionalInformation;
